export default function (state = [], action) {
  switch (action.type) {
    case "SELECTED_SUBSCRIPTIONS_ADMIN":
      return action.payload;
      break;
    default:
      return state;
  }
}
